'use strict';

module.exports = '<option <%= selected ? \'selected="selected"\' : \'\'%> class="ad-component_select--option <%= className %>"<% if(id) {%> id="<%= id %>"<%}%> value="<%= value %>"><%= label %></option>';



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/templates/ad-option.tpl.js
// module id = 28
// module chunks = 0